import { createSlice } from "@reduxjs/toolkit";

const loanSlice = createSlice({
  name: "Loan",
  initialState: {
    Loan: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: { 
    addLoanStart(state) {
        state.Loan.loading = true;
        state.Loan.error = null;
    },
    addLoanSuccess(state, action) {
        state.Loan.loading = false;
        state.Loan.data = action.payload;
    },
    addLoanFailure(state, action) {
        state.Loan.loading = false;
        state.Loan.error = action.payload;
    },   
    updateLoanStart(state) {
        state.Loan.loading = true;
        state.Loan.error = null;
    },
    updateLoanSuccess(state, action) {
        state.Loan.loading = false;
        state.Loan.data = action.payload;
    },
    updateLoanFailure(state, action) {
        state.Loan.loading = false;
        state.Loan.error = action.payload;
    },   
    fetchLoanStart(state) {
        state.Loan.loading = true;
        state.Loan.error = null;
    },
    fetchLoanSuccess(state, action) {
        state.Loan.loading = false;
        state.Loan.data = action.payload;
    },
    fetchLoanFailure(state, action) {
        state.Loan.loading = false;
        state.Loan.error = action.payload;
    },   
    deleteLoanStart(state) {
      state.Loan.loading = true;
      state.Loan.error = null;
  },
  deleteLoanSuccess(state, action) {
      state.Loan.loading = false;
      state.Loan.data = action.payload;
  },
  deleteLoanFailure(state, action) {
      state.Loan.loading = false;
      state.Loan.error = action.payload;
  },   
  },
});
export const {
  addLoanStart,
  addLoanSuccess,
  addLoanFailure,
  updateLoanStart,
  updateLoanSuccess,
  updateLoanFailure,
  fetchLoanStart,
  fetchLoanSuccess,
  fetchLoanFailure,
  deleteLoanStart,
  deleteLoanSuccess,
  deleteLoanFailure,
}= loanSlice.actions;

export default loanSlice.reducer;
